
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Youtube } from 'lucide-react';

export default function Footer() {
  return <footer className="py-12 border-t border-white/10 mt-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <Link to="/" className="flex items-center">
              <img src="/lovable-uploads/bfbf7207-f95c-4e56-94ae-89fe4b487cc9.png" alt="Aram AI Logo" className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-gray-400 max-w-md mt-2 md:mt-0">
              Aram AI's blog, sharing valuable insights, strategies, and experiences on the journey to becoming a top AI solopreneur and building impactful AI businesses.
            </p>
          </div>
          
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/iamaram.ai/" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram">
              <Instagram className="h-5 w-5" />
            </a>
            <a href="https://www.linkedin.com/in/aramai" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn">
              <Linkedin className="h-5 w-5" />
            </a>
            <a href="https://www.youtube.com/@iamaramai" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="YouTube">
              <Youtube className="h-5 w-5" />
            </a>
          </div>
        </div>
        
        <div className="mt-8 text-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Aram AI. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}
